module.exports = __webpack_public_path__ + "webpc/img/icon_assets_4.210bcd61.png";